import { api } from './api';

const API_URL = '/cases';

/**
 * Create case for user (idempotent - returns existing if user already has one)
 * @param {number} [visa_type_id] - Optional visa type ID
 */
export const createCase = async (visa_type_id) => {
  const response = await api.post(`${API_URL}/create`, { visa_type_id });
  return response.data;
};

/**
 * Get current user's case (auto-creates if not exists)
 */
export const getMyCase = async () => {
  const response = await api.get(`${API_URL}/my`);
  return response.data;
};

/**
 * Get all user's cases (drafts + submitted) for dashboard.
 */
export const getMyAll = async () => {
  const response = await api.get(`${API_URL}/my-all`);
  return response.data;
};

/**
 * Get user's submitted applications only (excludes drafts). Does NOT auto-create.
 * For "Cererile Mele" - nothing shown until user has submitted.
 */
export const getMyApplications = async () => {
  const response = await api.get(`${API_URL}/my-applications`);
  return response.data;
};

/**
 * Get dashboard data (case, documents, activities)
 */
export const getDashboard = async () => {
  const response = await api.get(`${API_URL}/dashboard`);
  return response.data;
};

/**
 * Get case by ID (must belong to current user)
 * @param {number} id - Case ID
 */
export const getCaseById = async (id) => {
  const response = await api.get(`${API_URL}/${id}`);
  return response.data;
};

/**
 * Delete case (only if belongs to current user)
 * @param {number} id - Case ID
 */
export const deleteCase = async (id) => {
  const response = await api.delete(`${API_URL}/${id}`);
  return response.data;
};

/**
 * Get full case details (case + step data + documents)
 * @param {number} caseId - Case ID
 */
export const getCaseDetail = async (caseId) => {
  const response = await api.get(`${API_URL}/${caseId}/detail`);
  return response.data;
};

/**
 * Save step data for a case (auto-save)
 * @param {number} caseId - Case ID
 * @param {number} step - Step number (1-4)
 * @param {object} data - Step form data
 */
export const saveStep = async (caseId, step, data) => {
  const response = await api.post(`${API_URL}/${caseId}/step`, { step, data });
  return response.data;
};

/**
 * Get step data for a case
 * @param {number} caseId - Case ID
 * @param {number} step - Step number (1-4)
 */
export const getStep = async (caseId, step) => {
  const response = await api.get(`${API_URL}/${caseId}/step/${step}`);
  return response.data;
};

/**
 * Submit case (after completing step 5 - documents)
 * @param {number} caseId - Case ID
 */
export const submitCase = async (caseId) => {
  const response = await api.post(`${API_URL}/${caseId}/submit`);
  return response.data;
};

export default {
  createCase,
  getMyCase,
  getMyAll,
  getMyApplications,
  getDashboard,
  getCaseById,
  deleteCase,
  getCaseDetail,
  saveStep,
  getStep,
  submitCase,
};
